import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import TableContext from './TableContext';
const VirtualVerticalContainer = function VirtualVerticalContainer(props) {
    const { children, renderBefore } = props;
    const { tableStore } = useContext(TableContext);
    let { virtualStartIndex } = tableStore;
    const { virtualEndIndex } = tableStore;
    const rows = [];
    if (renderBefore) {
        const before = renderBefore(virtualStartIndex);
        if (before) {
            rows.push(before);
        }
    }
    while (virtualStartIndex < virtualEndIndex) {
        rows.push(children(virtualStartIndex));
        virtualStartIndex++;
    }
    return React.createElement(React.Fragment, null, rows);
};
VirtualVerticalContainer.displayName = 'VirtualVerticalContainer';
export default observer(VirtualVerticalContainer);
